import { createError } from '#imports'
import type { Ref } from 'vue'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

import { OWNER_BY_PAGE_TYPE } from '../service/content-service.config'

import { usePageParamsFromRoute } from './usePageParamsFromRoute'

export function useHandleFetchError(
  error: Ref<
    | {
        status?: number
        message: string
      }
    | undefined
  >,
) {
  if (!error.value) {
    return
  }

  const logger = useLogger()

  const {
    pageType,
    pageName,
    pageCategory: category,
  } = usePageParamsFromRoute()

  const owner = OWNER_BY_PAGE_TYPE[pageType] || ''
  const pageCategory = category ? `[${category}]` : ''

  const message = `${owner}[${pageType}][${pageName}]${pageCategory} ${error.value.message}`
  logger.error(message, {
    owners: ['bot-squad-content-front', 'bot-group-onboard-front'],
  })

  throw createError({
    status: error.value.status,
    statusText: error.value.message,
    fatal: true,
  })
}
